export const logEvents = {
    COMPONENT_MOUNTED: 'COMPONENT MOUNTED',
    STATE_CHANGED: 'STATE CHANGED',
    EVENT_CALLED: 'EVENT CALLED',
    API_CALL: 'API CALL',
    EXTERNAL_EVENT_CALLED: 'EXTERNAL EVENT CALLED',
    INIT: 'INIT',
    UNHANDLED_ERROR: 'UNHANDLED ERROR',
    DOWNLOAD: 'DOWNLOAD',
    PARSE_DATA: 'PARSE DATA',
    LOAD_CACHE: 'LOAD CACHE',
    CLEAR_CACHE: 'CLEAR CACHE',
    REDIRECT: 'REDIRECT',
};

export const logLevels = {
    DEBUG: 'Debug',
    ERROR: 'Error',
    WARN: 'Warning',
    INFO: 'Information',
    LEVELS: ['Error', 'Warning', 'Information', 'Debug'],
};

export const localStorageKeys = {
    SPOTLIGHT_LANG: 'SPOTLIGHT_LANG',
    SPOTLIGHT_CACHE_FEATURES: 'SPOTLIGHT_CACHE_FEATURES',
    SPOTLIGHT_CACHE_APP_PRICES: 'SPOTLIGHT_CACHE_APP_PRICES',
    SPOTLIGHT_CACHE_DEVICE_DATA: 'SPOTLIGHT_CACHE_DEVICE_DATA',
    SPOTLIGHT_CACHE_PAYMENT_URLS: 'SPOTLIGHT_CACHE_PAYMENT_URLS',
    SPOTLIGHT_CACHE_DASHBOARD_URLS: 'SPOTLIGHT_CACHE_DASHBOARD_URLS',
    SPOTLIGHT_CACHE_PROMOTIONS: 'SPOTLIGHT_CACHE_PROMOTIONS',
    SPOTLIGHT_CACHE_LICENSES: 'SPOTLIGHT_CACHE_LICENSES',
    SPOTLIGHT_CACHE_APP_RECOMMENDATIONS: 'SPOTLIGHT_CACHE_APP_RECOMMENDATIONS',
    SPOTLIGHT_CACHE_PAYMENTS: 'SPOTLIGHT_CACHE_PAYMENTS',
    SPOTLIGHT_CACHE_TRANSACTIONS: 'SPOTLIGHT_CACHE_TRANSACTIONS',
    SPOTLIGHT_CACHE_PAYMENT_TYPES: 'SPOTLIGHT_CACHE_PAYMENT_TYPES',
    SPOTLIGHT_CACHE_NOTIFICATIONS: 'SPOTLIGHT_CACHE_NOTIFICATIONS',
    SPOTLIGHT_CACHE_LICENSE_INTEGRATIONS: 'SPOTLIGHT_CACHE_LICENSE_INTEGRATIONS',
    SPOTLIGHT_CACHE_PING: 'SPOTLIGHT_CACHE_PING',
    SPOTLIGHT_CACHE_APP_INSTANCES: 'SPOTLIGHT_CACHE_APP_INSTANCES',
    SPOTLIGHT_CACHE_APP_LICENSES: 'SPOTLIGHT_CACHE_APP_LICENSES',
};
